<app-main-content-card>
  <div class="title-bar">
    <h1>
      {{ "Kosárérték kedvezmény" | translate }}
    </h1>
  </div>
  <form class="easy-form" [formGroup]="formGroup!">
    <div class="d-flex flex-column">
      <div class="d-flex gap-5 mb-4">
        <mat-form-field>
          <label for="startDate">{{
            "Kezvezmény érvényességének kezdete" | translate
          }}</label>
          <div class="form-field-container date-field">
            <input
              id="startDate"
              formControlName="startDate"
              [matDatepicker]="pickerFrom"
              class="suffix"
              matInput
              (focus)="pickerFrom.open()"
              (ngModelChange)="onStartDateChange($event)"
            />
            <span matSuffix (click)="pickerFrom.open()">
              <mat-icon>today</mat-icon>
            </span>
            <mat-datepicker #pickerFrom></mat-datepicker>
          </div>
        </mat-form-field>
        <mat-form-field>
          <label for="endDate">{{
            "Kedvezmény érvényességének vége" | translate
          }}</label>
          <div class="form-field-container date-field">
            <input
              id="endDate"
              formControlName="endDate"
              [matDatepicker]="pickerTo"
              class="suffix"
              matInput
              [min]="endDateMinimum"
              (focus)="pickerTo.open()"
              (keydown)="onKeyDown($event)"
            />
            <span matSuffix (click)="pickerTo.open()">
              <mat-icon>today</mat-icon>
            </span>
            <mat-datepicker #pickerTo></mat-datepicker>
          </div>
        </mat-form-field>
      </div>

      <div class="table-container">
        <table
          class="price-ranges-table mat-table"
          [class.warning]="
            (formArray.touched &&
              formArray.hasError('invalidBasketDiscountsOverlap')) ||
            (formArray.touched &&
              formArray.hasError('invalidBasketDiscountsGap'))
          "
        >
          <thead>
            <tr class="mat-header-row">
              <th class="mat-header-cell">
                {{ "nettó min érték" | translate }}
              </th>
              <th class="mat-header-cell">
                {{ "nettó max érték" | translate }}
              </th>
              <th class="mat-header-cell">
                {{ "nettó kedvezmény" | translate }}
              </th>
              <th class="mat-header-cell">
                {{ "% vagy érték" | translate }}
              </th>
              <th class="mat-header-cell action-column"></th>
            </tr>
          </thead>
          <tbody formArrayName="basketDiscounts">
            <tr
              *ngFor="let group of formArray!.controls; let index = index"
              [formGroupName]="index"
              class="mat-row"
            >
              <td class="mat-cell">
                <mat-form-field class="form-field w-100">
                  <input
                    matInput
                    type="number"
                    formControlName="siteMinOrderValue"
                    [errorStateMatcher]="defaultErrorStateMatcher"
                    appLimitDecimalDigits
                    [decimals]="2"
                    [isNumberInput]="true"
                    (change)="onMinimumValueChange($event, index)"
                  /><span matTextSuffix>Ft</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field class="form-field w-100">
                  <input
                    matInput
                    type="number"
                    formControlName="siteMaxOrderValue"
                    appLimitDecimalDigits
                    [errorStateMatcher]="maxValueErrorStateMatcher"
                    [decimals]="2"
                    [isNumberInput]="true"
                    (change)="onMaximumValueChange($event, index)"
                  /><span matTextSuffix>Ft</span>
                </mat-form-field>
                <mat-error
                  class="mt-2"
                  *ngIf="
                    formArray
                      .at(index)
                      .get('siteMaxOrderValue')
                      ?.hasError('min')
                  "
                >
                  {{
                    "DELIVERY_MODE.EDIT.PRICING_RANGES_TABLE.MAX_VALUE_ERROR"
                      | translate
                  }}</mat-error
                >
              </td>
              <td class="mat-cell">
                <mat-form-field class="form-field w-100">
                  <input
                    matInput
                    type="number"
                    formControlName="discountValue"
                    appLimitDecimalDigits
                    [decimals]="2"
                    [isNumberInput]="true"
                  />
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <mat-form-field class="form-field w-100">
                  <mat-select
                    formControlName="discountMode"
                    (selectionChange)="discountModeChanged(index)"
                  >
                    <mat-option
                      *ngFor="let mode of discountModes"
                      [value]="mode"
                    >
                      {{ "BASKET_DISCOUNTS.DISCOUNT_MODE." + mode | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                    *ngIf="formArray.length - 1 === index"
                    type="button"
                    mat-icon-button
                    color="warn"
                    class="stroked"
                    (click)="deleteRow(index)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <mat-error
        class="mt-2"
        *ngIf="
          formArray.touched &&
          formArray.hasError('invalidBasketDiscountsOverlap')
        "
      >
        {{ "BASKET_DISCOUNTS.ERRORS.INVALID_OVERLAP" | translate }}</mat-error
      >
      <mat-error
        class="mt-2"
        *ngIf="
          formArray.touched && formArray.hasError('invalidBasketDiscountsGap')
        "
      >
        {{ "BASKET_DISCOUNTS.ERRORS.INVALID_GAP" | translate }}</mat-error
      >

      <div
        class="mt-4 add-button"
        [matTooltip]="
          isNewRowEnabled
            ? ''
            : ('DELIVERY_MODE.EDIT.PRICING_RANGES_TABLE.BTN_DISABLED_TOOLTIP'
              | translate)
        "
      >
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="addNewRow()"
          [disabled]="!isNewRowEnabled"
        >
          <mat-icon>add</mat-icon>
          {{ "DELIVERY_MODE.EDIT.PRICING_RANGES_TABLE.ADD_NEW" | translate }}
        </button>
      </div>

      <button
        class="mt-6 add-button"
        [disabled]="!formArray.length"
        type="button"
        mat-raised-button
        color="primary"
        (click)="save()"
      >
        {{ "SHARED.SAVE" | translate }}
      </button>
    </div>
  </form>
</app-main-content-card>
